import styled from '@emotion/styled';
import React from 'react';
import { useSelector } from 'react-redux';

import NotificationCard from 'components/notifications/Notification';
import { getNotifications } from 'modules/notifications/selectors/ui/dropdown/ids';
import { isLoadingSelector } from 'modules/notifications/selectors/ui/dropdown/isLoading';
import { isImpersonatingUser } from 'modules/users/selectors/currentUser';

import { Row, Col, Loader } from 'ui/base';

import Footer from './Footer';
import Header from './Header';
import Warning from './Warning';

const Wrapper = styled(Row)`
  width: calc(100vw * 0.45);
  max-width: 500px;
  background-color: white;
  border-radius: 2px;
  padding: 24px 0;
  gap: 24px;
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
`;

/**
 * @typedef {Object} Props
 * @property {function} onClick This function should be given by its parent (ie. Dropdown) to handle the hiding
 */

/** @type {React.FunctionComponent<Props>} */
const NotificationDropdown = ({ onClick: onClose }) => {
  const isLoading = useSelector(isLoadingSelector);
  const notifications = useSelector(getNotifications);
  const isImpersonating = useSelector(isImpersonatingUser);

  return (
    <Wrapper type="flex">
      <Col span={24}>
        <Header disabled={notifications.length === 0} onClick={onClose} />
      </Col>
      <Col span={24}>
        {!isImpersonating && <Warning onClick={onClose} />}
        {isLoading && <Loader className="d-flex justify-content-center" />}
        {!isLoading &&
          notifications.map(notification => (
            <NotificationCard key={notification.eventId} {...notification} onMenuClose={onClose} />
          ))}
      </Col>
      <Col span={24}>
        <Footer onClick={onClose} />
      </Col>
    </Wrapper>
  );
};

export default NotificationDropdown;
